export default __webpack_public_path__ + "img/093ddc3a3b2931dd622d90c4ffee28f1.mp4";